import { Routes } from "@angular/router";
import { ChallengesComponent } from "./challenges.component";

export const ChallengesRouting: Routes = [
  {
    path: '',
    children: [
      {
        path: 'detail',
        children: [
          {
            path: ':id',
            loadComponent: () => import('./pages/active-challenge-detail/active-challenge-detail.component').then(component => component.ActiveChallengeDetailComponent)
          }
        ]
      },
      {
        path: 'completed',
        children: [
          {
            path: ':id',
            loadComponent: () => import('./pages/user-finished-challenges/user-finished-challenges.component').then(component => component.UserFinishedChallengesComponent)
          }
        ]
      },
      {
        path: 'achievements',
        loadChildren: () => import('./pages/achievements/achievements.routing').then(r => r.ChallengesAchievementsRouting)
      },
      {
        path: 'setting',
        children: [
          {
            path: ':id',
            loadComponent: () => import('./pages/challenge-detail/challenge-detail.component').then(component => component.ChallengeDetailComponent)
          }
        ]
      },
      {
        path: 'progress',
        loadComponent: () => import('./pages/challenge-progress/challenge-progress.component').then(component => component.ChallengeProgressComponent)
      },
      {
        path: '',
        component: ChallengesComponent
      },
    ]
  },
]
